// extracted by mini-css-extract-plugin
export default {"map-wrapper":"map_map-wrapper__DYyn9","map-drawing-controls":"map_map-drawing-controls__VaqdP"};